import React from 'react'
import { useRosterState } from 'amazon-chime-sdk-component-library-react'
import { useTranslation } from 'react-i18next'

import { styled, SxProps } from '@mui/material/styles'
import Badge, { BadgeProps } from '@mui/material/Badge'
import Button from '@mui/material/Button'
import Tooltip from '@mui/material/Tooltip'
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'

import ControlBarItem from './ControlBarItem'

const MEDIA_PIPELINE_PREFIX = 'aws:MediaPipeline'

import colors from '@/assets/scss/_themes-vars.module.scss'
import _ from 'lodash'

type AttendeeControlProps = {
  sx?: SxProps
}

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: 0,
    top: 4,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))

export default function AttendeeControl(props: AttendeeControlProps) {
  const { sx } = props
  const { t } = useTranslation()
  const { roster } = useRosterState()
  const attendees = Object.values(roster)
  // One entry per user (a user may hold several Chime attendees across reconnects); all
  // recording pipelines collapse into one. External user ids are opaque, so never split them.
  const uniqueAttendees = _.uniqBy(attendees, (attendee) =>
    attendee?.externalUserId?.startsWith(MEDIA_PIPELINE_PREFIX) ? MEDIA_PIPELINE_PREFIX : attendee?.externalUserId
  )

  return (
    <ControlBarItem disableMargin>
      <Tooltip title={<span>{t('component.chimeSDK.attendeeControl.attendeeButton.tooltip')}</span>} arrow>
        <Button variant="neutral" sx={sx}>
          <StyledBadge badgeContent={uniqueAttendees.length} color="primary">
            <AccountCircleOutlinedIcon htmlColor={colors.gray500} />
          </StyledBadge>
        </Button>
      </Tooltip>
    </ControlBarItem>
  )
}
